import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { formatPercent } from "../../lib";

type Row = {
  category: string;
  ord: number;
  user_count: number | string;
  claim_count: number | string;
};

// Confirmed substitutes bucketed by lifetime active claims, from
// GET /api/stats/sub-engagement. Superuser only.
export const sub_engagement: Query<Ctx> = async ({ sb }, _params) => {
  const { data, error } = await sb.functions.invoke<Row[] | null>(
    "api/stats/sub-engagement",
    { method: "GET" }
  );
  if (error) console.error("sub_engagement:", error);
  const rows = data ?? [];

  const total_users = rows.reduce((sum, r) => sum + Number(r.user_count), 0);
  const total_claims = rows.reduce((sum, r) => sum + Number(r.claim_count), 0);

  return rows.map((row) => {
    const user_pct =
      total_users > 0 ? Number(row.user_count) / total_users : null;
    const claim_pct =
      total_claims > 0 ? Number(row.claim_count) / total_claims : null;
    return {
      category: row.category,
      user_count: Number(row.user_count),
      user_pct,
      f_user_pct: formatPercent(user_pct),
      claim_count: Number(row.claim_count),
      claim_pct,
      f_claim_pct: formatPercent(claim_pct),
    };
  });
};
